// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductPage_container__1oCB3","slider":"ProductPage_slider__2G5q9"};